// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table td[data-v-56fa0ccd]{\n    border-top: none;\n}\n.spinbox input[data-v-56fa0ccd]::-webkit-outer-spin-button,\n.spinbox input[data-v-56fa0ccd]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.spinbox input[type=number][data-v-56fa0ccd] {\n  -moz-appearance: textfield;\n  -webkit-appearance: textfield;\n          appearance: textfield;\n}\n", ""]);
// Exports
module.exports = exports;
